export default {"src":"/_next/static/media/hearts.d220286f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};